export interface TableFieldSelect {
    data_list: string;
    key: string;
    display: string;
    search_key?: string;
    searchable?: boolean;
}

export interface TableField {
    key: string;
    label: string;
    type: string;
    editable?: boolean;
    sortable?: boolean;
    model_key?: string;
    value?: string;
    isMandatory?: boolean;
    mandatoryMessage?: string;
    multipleColumns?: boolean;
    select?: TableFieldSelect;
}

export interface TableDetails {
    titleList?: string;
    titleEdit?: string;
    create?: boolean;
    createLabel?: string;
    submitLabel?: string;
    delete?: boolean;
    edit?: boolean;
    hasMediaFile?: boolean;
    hasMediaFiles?: boolean;
    mediaFileType?: string;
    sortby?: string;
}

export interface TableAction {
    label: string;
    action: string;
    class: string;
}

export interface TableData {
    details: TableDetails;
    fields: TableField[];
    actions?: TableAction[];
}

export interface ListRecord {
    uuid: string;
    description?: string;
    unit_price_inc_tax?: number;
    media_file?: MediaFile;
    [key: string]: unknown;
}

export interface MediaFile {
    uuid?: string;
    url?: string;
    file_name?: string;
    file_path?: string;
}

/** Shape expected by ImageGallery.svelte */
export interface GalleryMediaFile {
    uuid: string;
    file_name?: string;
    file_path?: string;
    url?: string;
}

export function toGalleryMediaFiles(files: MediaFile[] | undefined): GalleryMediaFile[] {
    return (files ?? []).map((f, index) => ({
        uuid: typeof f.uuid === 'string' ? f.uuid : `local-${index}`,
        file_name: f.file_name,
        file_path: f.file_path,
        url: f.url,
    }));
}

export type FormDataRecord = Record<string, unknown> & {
    media_file?: MediaFile;
    media_files?: MediaFile[];
};

export interface IndexParams {
    page?: number;
    phrase?: string;
    column?: string;
    order?: string;
    [key: string]: string | number | undefined;
}

export const emptyTableData: TableData = {
    fields: [],
    details: {},
};

export function getSelectOptions(
    lists: Record<string, unknown> | null,
    dataList: string,
): Record<string, unknown>[] {
    if (!lists) return [];
    const items = lists[dataList];
    return Array.isArray(items) ? (items as Record<string, unknown>[]) : [];
}

export function optionProp(option: Record<string, unknown>, key: string): string {
    const value = option[key];
    return value == null ? '' : String(value);
}
